module.exports = __webpack_public_path__ + "img/smallTruck-dark-grey.4553e84a.svg";